import { Injectable } from '@angular/core';
import { Action, State, StateContext } from '@ngxs/store';
import { Appointment, Claim, Dossier } from '@sc/data-access-models';

import {
  ClearDossierAction,
  PatchAppointmentAction,
  PatchClaimAction,
  PatchDossierAction,
  SetDossierAction,
} from './dossier.actions';

@State<Partial<Dossier>>({
  name: 'dossier',
  defaults: null,
})
@Injectable()
export class DossierState {
  @Action(SetDossierAction)
  set(
    ctx: StateContext<Partial<Dossier>>,
    { dossier }: SetDossierAction
  ): void {
    ctx.setState({ ...dossier });
  }

  @Action(PatchDossierAction)
  patch(
    ctx: StateContext<Partial<Dossier>>,
    { payload }: PatchDossierAction
  ): void {
    const state = ctx.getState() ? ctx.getState() : ({} as Dossier);

    ctx.setState({ ...state, ...payload });
  }

  @Action(ClearDossierAction)
  clear(ctx: StateContext<Partial<Dossier>>): void {
    ctx.setState(null);
  }

  @Action(PatchClaimAction)
  patchClaim(
    ctx: StateContext<Partial<Dossier>>,
    { payload }: PatchClaimAction
  ): void {
    const globalState = ctx.getState() ? ctx.getState() : ({} as Dossier);
    const claimState = globalState.claim ? globalState.claim : ({} as Claim);

    ctx.setState({
      ...globalState,
      claim: { ...claimState, ...payload },
    });
  }

  @Action(PatchAppointmentAction)
  patchAppointment(
    ctx: StateContext<Partial<Dossier>>,
    { payload }: PatchAppointmentAction
  ): void {
    const globalState = ctx.getState() ? ctx.getState() : ({} as Dossier);
    const appointmentState = globalState.appointment
      ? globalState.appointment
      : ({} as Appointment);

    ctx.setState({
      ...globalState,
      appointment: { ...appointmentState, ...payload },
    });
  }
}
